/* One transport and one drawer intent for the storefront cart. No automatic POST retry. */
(function () {
  'use strict';
  if (window.BizDecksCart || typeof window.fetch !== 'function' || typeof AbortController !== 'function') return;

  var nativeFetch = window.fetch.bind(window);
  var config = window.BizDecksCartConfig || {};
  var timeoutMs = Math.max(50, Number(config.requestTimeoutMs) || 12000);
  var revision = 0, pendingWrites = 0, writing = false, uncertain = false;
  var writeTail = Promise.resolve(), recovery = null, refreshPromise = null, cartReadFlight = null;
  var phase = 'closed', wantsOpen = false, intent = 0, lastCart = null, status = '', message = '', recoveredUnknown = false;
  var busyButtons = new Map(), recoveries = [], installed = false, unresolved = null, addPending = false;
  var replay = window.BizDecksCartSupport && window.BizDecksCartSupport.addReceipts;
  if(!replay){var held=[];replay={remember:function(items,before){held.push({items:items,before:before});},find:function(items){return held.filter(function(entry){return entry.items.some(function(a){return items.some(function(b){return itemKey(a)===itemKey(b);});});});},fulfilled:function(entry,cart){return provesChange(Object.assign({kind:'add'},entry),cart);},forget:function(entries){held=held.filter(function(entry){return entries.indexOf(entry)<0;});},rendered:function(cart){this.forget(held.filter(function(entry){return provesChange(Object.assign({kind:'add'},entry),cart);}));},hasPending:function(){return held.length>0;}};}
  var UNKNOWN_KEY = 'bd-cart-unconfirmed-v1', uncertainSince = 0, failureEpoch = 0;
  var recoveryQuietMs = Math.max(500, Math.min(2000, timeoutMs));
  try { var savedUnknown = sessionStorage.getItem(UNKNOWN_KEY); uncertain = savedUnknown === '1' || /^\d{10,14}$/.test(savedUnknown || ''); if (uncertain) uncertainSince = savedUnknown === '1' ? Date.now() : Number(savedUnknown); } catch (_) {}
  function rememberUnknown() { try { if (uncertain) sessionStorage.setItem(UNKNOWN_KEY, String(uncertainSince || Date.now())); else sessionStorage.removeItem(UNKNOWN_KEY); } catch (_) {} }
  function markUnknown(entry) { entry.unconfirmed=true;if(entry.kind==='add'&&entry.info.receivedStatus!==422)entry.receipts=replay.remember(entry.items,entry.before); uncertain = true; unresolved = entry; uncertainSince = Date.now(); failureEpoch += 1; rememberUnknown(); }
  var cartSeenAt = 0;
  var DEFAULT_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function syncCheckout(cart) { try { var c = window.BizDecksCheckoutState; if (c && typeof c.syncCart === "function") c.syncCart(cart); } catch (_) {} }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  /* AUDIT-25 (25 Oct 2026): status and error texts in the visitor's language. snippets/cart-drawer.liquid prints
     bd_i18n.cart.* as JSON (script[data-bd-cart-i18n]); English stays the fallback for every text (e.g. on /cart). */
  var i18n = null;
  function T(key, fallback) { if (!i18n) { try { var n = document.querySelector('script[data-bd-cart-i18n]'); i18n = n ? JSON.parse(n.textContent) || {} : null; } catch (_) { i18n = {}; } } var v = i18n && i18n[key]; return typeof v === 'string' && v && v.indexOf('translation missing') === -1 ? v : fallback; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function error(text, name) { var e = new Error(text); e.name = name || 'CartError'; return e; }
  function emit(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (_) {} }
  function currentRevision(value) { return typeof value === 'number' && Number.isFinite(value); }
  /* Monitoring is optional and never sits on the cart's request or UI completion path. */
  function monitor(method, context) {
    try {
      var logger = window.BizDecksErrorMonitor;
      if (!logger || typeof logger[method] !== 'function') return null;
      var result = logger[method](context);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return typeof result === 'string' ? result : null;
    } catch (_) { return null; }
  }
  function endpoint(input, init) {
    try {
      var url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href);
      if (url.searchParams.has('sections') || url.searchParams.has('section_id')) return '/sections';
      var match = url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/);
      return match ? '/cart/' + match[1] + '.js' : '/cart.js';
    } catch (_) { return '/cart.js'; }
  }
  function beginAction(interaction, extra) {
    var context = Object.assign({ interaction: interaction, cart_version: revision, source: 'theme' }, extra || {});
    context.action_ref = monitor('markActionStarted', context);
    return context;
  }
  function actionDone(method, context, extra) {
    if (context && context.action_ref) monitor(method, Object.assign({}, context, extra || {}, { cart_version: revision }));
  }
  function customerCanSeeNotice() {
    var d = drawer(), notice = d && d.querySelector('[data-bd-cart-status]');
    var inDrawer = !!(notice && d.classList.contains('active') && d.getAttribute('aria-hidden') === 'false' && notice.getClientRects().length);
    var page = document.getElementById('cart-errors');
    return inDrawer || !!(page && page.textContent && page.getClientRects().length);
  }
  function recordError(e, options) {
    if (e && e.bdMonitorCaptured) return;
    var context = Object.assign({ error_code: 'CART_INVALID_RESPONSE', interaction: 'refresh_cart', cart_version: revision, source: 'theme' }, options || {});
    context.customer_visible = customerCanSeeNotice();
    var id = monitor(context.customer_visible ? 'captureVisibleError' : 'capture', context);
    if (e) e.bdMonitorCaptured = true;
    if (id && /^(CART_FETCH_|CART_INVALID_|CART_MUTATION_(TIMEOUT|NETWORK|ABORTED)|CART_DRAWER_REFRESH_FAILED)/.test(context.error_code)) {
      recoveries.push({ event_id: id, action_ref: context.action_ref, stage: /^CART_MUTATION_/.test(context.error_code) ? 'mutation' : context.error_code === 'CART_DRAWER_REFRESH_FAILED' ? 'render' : 'read' });
      if (recoveries.length > 20) recoveries.shift();
    }
  }
  function recovered(stage, currentAction) {
    recoveries = recoveries.filter(function (entry) {
      if (entry.stage !== stage) return true;
      var recoveryAction = !entry.action_ref && !currentAction ? beginAction('refresh_cart') : currentAction;
      var recoveryRef = entry.action_ref || recoveryAction && recoveryAction.action_ref;
      if (recoveryAction && !currentAction) actionDone('markActionSucceeded', recoveryAction);
      if (recoveryRef) monitor('markRecovered', { action_ref: recoveryRef, parent_event_id: entry.event_id, interaction: 'refresh_cart', cart_version: revision, outcome: 'recovered', source: 'theme' });
      return false;
    });
  }
  function readCode(e) {
    return e && e.name === 'TimeoutError' ? 'CART_FETCH_TIMEOUT' : e && e.name === 'SyntaxError' ? 'CART_INVALID_JSON' : e && e.name === 'CartInvalidResponseError' ? 'CART_INVALID_RESPONSE' : 'CART_FETCH_HTTP';
  }
  function requestInfo(input, init) {
    var url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href);
    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var match = url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/);
    var headers = new Headers((init && init.headers) || (input && input.headers) || {});
    var cartPath = root() + 'cart';
    var cartEndpoint = url.pathname === cartPath || url.pathname === cartPath + '/' || url.pathname === cartPath + '.js';
    var requested = (url.searchParams.get('sections') || url.searchParams.get('section_id') || '').split(',').filter(Boolean);
    var known = DEFAULT_SECTIONS.concat(['main-cart-items', 'main-cart-footer', 'cart-live-region-text']);
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) { var node = document.getElementById(id); if (node && node.dataset.id) known.push(node.dataset.id); });
    var cartSections = requested.length > 0 && requested.every(function (name) { return known.indexOf(name) !== -1; });
    return { url: url, method: method, mutation: url.origin === location.origin && method === 'POST' && match ? match[1] : '',
      read: url.origin === location.origin && (method === 'GET' || method === 'HEAD') && (requested.length ? cartSections : cartEndpoint),
      mine: headers.get('X-BD-WB') === '1', completed: false };
  }

  /* Buffer the body inside the same deadline as fetch. A successful header alone is not completion. */
  async function boundedFetch(input, init, info) {
    var controller = new AbortController(), timer, listener;
    var started = performance.now(), httpStatus = null, safeEndpoint = endpoint(input, init);
    var callerSignal = (init && init.signal) || (input && input.signal);
    var cancelled = false;
    var deadline = new Promise(function (_, reject) {
      timer = setTimeout(function () { cancelled = true; controller.abort(); reject(error('Your cart request took too long.', 'TimeoutError')); }, timeoutMs);
      if (callerSignal) {
        listener = function () { cancelled = true; controller.abort(); reject(error('The cart request was interrupted.', 'AbortError')); };
        if (callerSignal.aborted) listener();
        else callerSignal.addEventListener('abort', listener, { once: true });
      }
    });
    try {
      return await Promise.race([(async function () {
        if (cancelled) throw error('The cart request was interrupted.', 'AbortError');
        if (info) info.dispatched = true;
        var original = await nativeFetch(input, Object.assign({}, init || {}, { signal: controller.signal }));
        httpStatus = original.status; if(info)info.receivedStatus=original.status;
        var buffer = await original.arrayBuffer();
        var response = new Response(original.status === 204 || original.status === 205 ? null : buffer, {
          status: original.status, statusText: original.statusText, headers: original.headers
        });
        try { Object.defineProperty(response, 'url', { value: original.url }); } catch (_) {}
        if (info) { info.completed = true; info.completedStatus = original.status; if(info.onCompleted)info.onCompleted(response); }
        response.bdCartRequest = { request_endpoint: safeEndpoint, http_status: httpStatus, duration_ms: Math.round(performance.now() - started), cart_version: revision, action_ref: info && info.action_ref || null };
        return response;
      })(), deadline]);
    } catch (e) {
      e.bdCartRequest = { request_endpoint: safeEndpoint, http_status: httpStatus, duration_ms: Math.round(performance.now() - started), cart_version: revision, action_ref: info && info.action_ref || null };
      throw e;
    } finally {
      clearTimeout(timer);
      if (callerSignal && listener) callerSignal.removeEventListener('abort', listener);
      monitor('recordRequest', { request_endpoint: safeEndpoint, http_status: httpStatus, duration_ms: Math.round(performance.now() - started), cart_version: revision, action_ref: info && info.action_ref || null });
    }
  }

  function annotate(response, atRevision) {
    response.bdCartRevision = atRevision;
    var json = response.json.bind(response), clone = response.clone.bind(response);
    response.json = async function () {
      var data = await json();
      if (data && typeof data === 'object') {
        data.bdCartRevision = atRevision;
        if (response.bdCartActionRef) data.bdCartActionRef = response.bdCartActionRef;
        if (response.bdCartValidation) data.bdCartValidation = response.bdCartValidation;
      }
      return data;
    };
    response.clone = function () {
      var copy = annotate(clone(), atRevision);
      copy.bdCartOutcome = response.bdCartOutcome; copy.bdCartAddConfirmed = response.bdCartAddConfirmed; copy.bdCartPartialPossible = response.bdCartPartialPossible;
      copy.bdCartActionRef = response.bdCartActionRef; copy.bdCartValidation = response.bdCartValidation; copy.bdCartRequest = response.bdCartRequest;
      return copy;
    };
    return response;
  }

  function paintDrawerStatus() {
    var d = drawer();
    if (d) {
      d.dataset.bdAddPending=addPending||replay.hasPending()?'true':'false';
      d.setAttribute('aria-busy', writing || status === 'loading' ? 'true' : 'false');
      d.dataset.bdCartState = uncertain ? 'uncertain' : status || 'ready';
      var host = d.querySelector('.drawer__inner') || d.querySelector('#CartDrawer');
      if (host) {
        var notice = host.querySelector('[data-bd-cart-status]');
        if (!status && !message) { if (notice) notice.remove(); }
        else {
          if (!notice) {
            notice = document.createElement('div'); notice.dataset.bdCartStatus = 'true'; notice.dataset.bdMonitorOwned = 'true';
            notice.style.cssText = 'margin:12px 20px;padding:12px 14px;border:1px solid #bfdbfe;border-radius:8px;background:#eff6ff;color:#172554;line-height:1.45';
            var header = host.querySelector('.drawer__header');
            if (header && header.parentNode === host) header.after(notice); else host.prepend(notice);
          }
          notice.replaceChildren();
          notice.setAttribute('role', status === 'error' ? 'alert' : 'status');
          notice.setAttribute('aria-live', status === 'error' ? 'assertive' : 'polite');
          var text = document.createElement('p'); text.style.margin = '0 0 8px';
          text.textContent = message || T('updating', 'Updating your cart...'); notice.appendChild(text);
          if (status === 'error') {
            var retry = document.createElement('button'); retry.type = 'button'; retry.dataset.bdCartRetry = 'true';
            retry.className = 'button button--secondary'; retry.textContent = T('retry', 'Check cart again');
            retry.addEventListener('click', function () { refresh().catch(function () {}); }); notice.appendChild(retry);
            if (!uncertain && !writing && replay.hasPending() && typeof replay.acknowledge === 'function') {
              var allow = document.createElement('button'); allow.type = 'button'; allow.dataset.bdCartAllowAdd = 'true';
              allow.className = 'button button--secondary'; allow.textContent = T('allow_add', 'I checked my cart, allow another add');
              allow.addEventListener('click', async function () {
                allow.disabled = true;
                try {
                  var checked = await readCart();
                  if (uncertain || writing || pendingWrites || checked.bdCartRevision !== revision) throw error('Your cart is still changing. Check it again before continuing.');
                  // Explicit customer acknowledgement only. This never sends or replays a POST.
                  replay.acknowledge(); addPending = false; recoveredUnknown = false;
                  setStatus('error', T('allowed', 'Another add is now available. The earlier request may still arrive. Review your quantities before checkout.'));
                } catch (e) { reportError(e); }
                finally { if (allow.isConnected) allow.disabled = false; }
              }); notice.appendChild(allow);
            }
          }
          var link = document.createElement('a'); link.href = root() + 'cart'; link.textContent = T('view_cart', 'View full cart');
          link.style.cssText = 'display:inline-block;margin-left:12px;text-decoration:underline'; notice.appendChild(link);
        }
      }
    }
  }
  function paintStatus() {
    try { paintDrawerStatus(); } catch (_) { /* Presentation cannot reject a cart mutation. */ }
    try {
      var checkout = window.BizDecksCheckoutState;
      if (checkout && typeof checkout.set === 'function') { checkout.set('mutation', writing); return; }
      document.querySelectorAll('#checkout, #CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]').forEach(function (button) {
        if (writing && !button.disabled) { busyButtons.set(button, button.getAttribute('aria-disabled')); button.dataset.bdCartBusy = 'true'; button.disabled = true; button.setAttribute('aria-disabled', 'true'); }
      });
      if (!writing) {
        busyButtons.forEach(function (aria, button) { if (button.isConnected) {
          delete button.dataset.bdCartBusy;
          if (button.dataset.bdPhysicalDeliveryDisabled !== 'true' && !button.dataset.bdCheckoutReasons) { button.disabled = false; if (aria === null) button.removeAttribute('aria-disabled'); else button.setAttribute('aria-disabled', aria); }
        }}); busyButtons.clear();
      }
    } catch (_) {}
  }
  function readyStatus() {
    if (replay.hasPending()) {
      setStatus('error', T('pending', 'Your last add is still unconfirmed.') + ' ' + (lastCart && lastCart.item_count === 0 ? T('now_empty', 'Your cart is currently empty.') + ' ' : '') + T('pending_tail', 'Check your cart before allowing another add. The earlier request may still arrive. Review quantities before checkout.'));
    } else {
    setStatus(recoveredUnknown ? 'error' : '', recoveredUnknown ? T('checked', 'Your cart has been checked. Review the quantities before continuing.') : '');
    }
    var pageError = document.getElementById('cart-errors');
    if (!recoveredUnknown && pageError && pageError.dataset.bdCartOwnedError === 'true') { pageError.textContent = ''; delete pageError.dataset.bdCartOwnedError; }
  }
  function setStatus(next, text) {
    status = next || ''; message = text || '';
    if (wantsOpen) phase = status === 'loading' ? (lastCart ? 'refreshing' : 'opening') : 'open';
    paintStatus();
  }
  function reportError(e, options) {
    var specific = options && typeof options.message === 'string' ? options.message.slice(0, 600) : e && e.bdCartMessage || '';
    setStatus('error', uncertain ? T('err_uncertain', 'We could not confirm your last change. Check your cart before trying again. Do not add the same item again yet.') : specific || T('err_generic', 'Your cart could not be updated. Check your cart again or open the full cart.'));
    var pageError = document.getElementById('cart-errors');
    if (pageError) { pageError.textContent = message; pageError.dataset.bdCartOwnedError = 'true'; pageError.dataset.bdMonitorOwned = 'true'; }
    var context = Object.assign({}, e && e.bdCartRequest || {}, e && e.bdCartContext || {}, { error_code: options && options.error_code || e && e.bdCartCode || (specific ? 'CART_ADD_REJECTED' : readCode(e)) });
    if (!options || options.record !== false) recordError(e, context);
    emit('bd:cart:error', { name: e && e.name || 'CartError', uncertain: uncertain });
  }

  function noteOpen(trigger) {
    if (!wantsOpen) phase = 'opening';
    wantsOpen = true; intent += 1;
    var d = drawer(); if (d && trigger && typeof d.setActiveElement === 'function') d.setActiveElement(trigger);
    return intent;
  }
  function open(options) {
    options = options || {};
    var firstOpen = !wantsOpen;
    var openAction = firstOpen ? beginAction('open_cart') : null;
    if (firstOpen) monitor('capture', { error_code: 'CART_OPEN_REQUESTED', interaction: 'open_cart', action_ref: openAction.action_ref, cart_version: revision });
    noteOpen(options.trigger);
    var d = drawer(), openingError = null;
    if (d) {
      try {
        if (typeof d.open === 'function' && !d.classList.contains('active')) d.open(options.trigger, { coordinator: true });
        else if (typeof d.open !== 'function') { d.classList.add('active', 'animate'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('overflow-hidden'); }
      } catch (e) {
        openingError = e;
        /* A drawer presentation fault must not turn a valid purchase request into a lost add. */
        d.classList.add('active', 'animate'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('overflow-hidden');
      }
    }
    if (firstOpen) {
      if (d && d.classList.contains('active') && !openingError) {
        actionDone('markActionSucceeded', openAction);
        monitor('capture', { error_code: 'CART_OPENED', interaction: 'open_cart', action_ref: openAction.action_ref, cart_version: revision });
      } else {
        actionDone('markActionFailed', openAction);
        var missingDrawer = openingError || error('The cart drawer is unavailable.');
        missingDrawer.bdCartCode = 'CART_DRAWER_OPEN_FAILED'; missingDrawer.bdCartContext = openAction; reportError(missingDrawer);
      }
    }
    paintStatus();
    return options.refresh === false ? Promise.resolve(lastCart) : refresh(options);
  }
  function noteClosed() { wantsOpen = false; phase = 'closing'; intent += 1; }
  function finishClosed() { if (!wantsOpen) phase = 'closed'; }

  function rawReadCart(context) {
    if (cartReadFlight && cartReadFlight.revision === revision) return cartReadFlight.promise;
    var atRevision = revision;
    var flight = { revision: atRevision, promise: null };
    flight.promise = (async function () {
      var response = await boundedFetch(root() + 'cart.js', { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }, context);
      var cart;
      try {
        if (!response.ok) throw error('Your cart could not be read.');
        cart = await response.json();
        if (!cart || !Array.isArray(cart.items) || typeof cart.item_count !== 'number') throw error('Your cart response was incomplete.', 'CartInvalidResponseError');
      } catch (e) { e.bdCartRequest = response.bdCartRequest; throw e; }
      if(replay.observe)replay.observe(cart);
      cart.bdCartRevision = atRevision;
      return cart;
    })().finally(function () { if (cartReadFlight === flight) cartReadFlight = null; });
    cartReadFlight = flight;
    return flight.promise;
  }

  function itemKey(item) {
    var props = item && item.properties || {};
    return JSON.stringify([String(item && (item.variant_id || item.id) || ''), String(item && (item.selling_plan || item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || ''), Object.keys(props).sort().map(function (key) { return [key, String(props[key])]; })]);
  }
  function provesChange(entry, cart) {
    if (!entry || !entry.before) return false;
    if (entry.kind === 'add') {
      if (!entry.items.length) return false;
      var before = {}, after = {}, needed = {};
      entry.before.items.forEach(function (item) { var key = itemKey(item); before[key] = (before[key] || 0) + Number(item.quantity || 0); });
      cart.items.forEach(function (item) { var key = itemKey(item); after[key] = (after[key] || 0) + Number(item.quantity || 0); });
      entry.items.forEach(function (item) { var key = itemKey(item); needed[key] = (needed[key] || 0) + Math.max(1, Number(item.quantity) || 1); });
      return Object.keys(needed).every(function (key) { return (after[key] || 0) >= (before[key] || 0) + needed[key]; }) || entry.partialAllowed && Object.keys(needed).some(function (key) { return (after[key] || 0) > (before[key] || 0); });
    }
    // An absolute quantity change is confirmed only by its matching target state.
    if (entry.kind === 'change' && entry.body) {
      var id = String(entry.body.id || ''), prior = entry.before.items.find(function (item, index) { return id ? String(item.key) === id || String(item.variant_id) === id : index + 1 === Number(entry.body.line); });
      if (!prior) return false;
      var line = cart.items.find(function (item) { return itemKey(item) === itemKey(prior); });
      return Number(entry.body.quantity) === 0 ? !line : !!line && Number(line.quantity) === Number(entry.body.quantity);
    }
    if (entry.kind === 'update' && entry.body && entry.body.updates && !Array.isArray(entry.body.updates)) {
      return Object.keys(entry.body.updates).length > 0 && Object.keys(entry.body.updates).every(function (id) {
        var prior = entry.before.items.find(function (item) { return String(item.key) === id; });
        if (!prior) return false;
        var target = cart.items.find(function (item) { return itemKey(item) === itemKey(prior); });
        var quantity = Number(entry.body.updates[id]); return quantity === 0 ? !target : !!target && target.quantity === quantity;
      });
    }
    if (entry.kind === 'clear') return cart.item_count === 0;
    return false;
  }
  function cartFingerprint(cart) {
    return JSON.stringify([cart.currency, cart.total_price, cart.items.map(function (item) { return [itemKey(item), Number(item.quantity), item.final_line_price]; }).sort(function (a,b) { return a[0].localeCompare(b[0]); })]);
  }
  async function reconcile() {
    if (recovery) return recovery;
    recovery = (async function () {
      try {
        var cart = await rawReadCart(), confirmed = provesChange(unresolved, cart);
        // A client abort cannot later deliver a completed response. Recover from fresh
        // server state instead. Unchanged/legacy state requires two matching snapshots
        // over a quiet period, never just an old read or an expiring session flag.
        for (var check = 0; !confirmed && check < 2; check += 1) {
          var fingerprint = cartFingerprint(cart);
          await new Promise(function (resolve) { setTimeout(resolve, recoveryQuietMs); });
          var next = await rawReadCart();
          confirmed = provesChange(unresolved, next) || fingerprint === cartFingerprint(next);
          cart = next;
        }
        lastCart = cart; cartSeenAt = Date.now(); syncCheckout(cart);
        if (confirmed) {
          uncertain = false; unresolved = null; uncertainSince = 0; rememberUnknown(); recoveredUnknown = true;
          recovered('mutation'); emit('bd:cart:reconciled', { revision: revision, cart: cart });
        }
        if (uncertain) setStatus('error', T('err_still', 'Your last change is still unconfirmed. Review your cart. Do not add the same item again.'));
        else readyStatus();
        return cart;
      } catch (e) { reportError(e); throw e; }
      finally { recovery = null; }
    })();
    return recovery;
  }
  async function readCart() {
    try {
      for (var attempt = 0; attempt < 3; attempt += 1) {
        await writeTail;
        var cart = uncertain ? await reconcile() : await rawReadCart();
        if (cart.bdCartRevision === revision && !writing) { lastCart = cart; cartSeenAt = Date.now(); syncCheckout(cart); recovered('read'); return cart; }
      }
      var stale = error('Your cart is still changing. Check it again in a moment.'); stale.bdCartCode = 'CART_STALE_RESPONSE'; throw stale;
    } catch (e) { reportError(e); throw e; }
  }

  async function itemsFor(input, init) {
    var body = init && init.body;
    if (body == null && input && typeof input.clone === 'function') {
      var bodyTimer;
      try { body = await Promise.race([input.clone().text(), new Promise(function (_, reject) { bodyTimer = setTimeout(function () { reject(error('Your cart request could not be prepared.', 'TimeoutError')); }, timeoutMs); })]); }
      finally { clearTimeout(bodyTimer); }
    }
    if (typeof body === 'string') {
      try { var data = JSON.parse(body); return Array.isArray(data.items) ? data.items : data.id ? [data] : []; }
      catch (_) { body = new URLSearchParams(body); }
    }
    if (body && typeof body.forEach === 'function') {
      var item = { quantity: 1, properties: {} }, indexed = {};
      body.forEach(function (value, key) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan') item[key] = value;
        var property = key.match(/^properties\[(.+)\]$/); if (property) item.properties[property[1]] = value;
        var field = key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/);
        if (field) { indexed[field[1]] = indexed[field[1]] || { properties: {} }; indexed[field[1]][field[2]] = value; }
        var prop = key.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
        if (prop) { indexed[prop[1]] = indexed[prop[1]] || { properties: {} }; indexed[prop[1]].properties[prop[2]] = value; }
      });
      return item.id ? [item] : Object.keys(indexed).map(function (key) { return indexed[key]; });
    }
    return body && typeof body === 'object' ? Array.isArray(body.items) ? body.items : body.id ? [body] : [] : [];
  }

  function scheduleRefresh() { setTimeout(function () { refresh().catch(function () {}); }, 0); }
  function coordinatedFetch(input, init) {
    var info;
    try { info = requestInfo(input, init); } catch (_) { return nativeFetch(input, init); }
    if (!info.mutation) {
      if (!info.read) return nativeFetch(input, init);
      var atRevision = revision;
      return boundedFetch(input, init, info).then(function (response) { return annotate(response, atRevision); }).catch(function (e) { e.bdCartCode = readCode(e); reportError(e); throw e; });
    }
    var trigger = document.activeElement;
    /* Add intent belongs to the user's action, never to a later response or a Workbook repair. */
    if (info.mutation === 'add' && !info.mine) { addPending=true; try { open({ trigger: trigger, refresh: false }); setStatus('loading', T('adding', 'Adding to your cart...')); } catch (_) {} }
    pendingWrites += 1;
    var queuedEpoch = failureEpoch;
    var operation = writeTail.then(async function () {
      var requestedItems = info.mutation === 'add' ? await itemsFor(input, init) : [];
      var before = lastCart && lastCart.bdCartRevision === revision ? lastCart : null;
      var requestBody = null; try { requestBody = JSON.parse(init && init.body || '{}'); } catch (_) {}
      var entry = {kind: info.mutation, items: requestedItems, before: before, body: requestBody, info: info, validationCompleted: false};
      info.onCompleted=function(response){
        if(!entry.unconfirmed||entry.kind!=='add'||!replay.complete)return;
        replay.complete(entry.items,response,entry.receipts).then(function(done){
          if(!done)return;
          if(unresolved===entry){uncertain=false;unresolved=null;uncertainSince=0;rememberUnknown();recoveredUnknown=true;}
          if(response.status===422)addPending=false;
          scheduleRefresh();
        }).catch(function(){});
      };
      if (uncertain || queuedEpoch !== failureEpoch) { var blocked = error('Check your cart before making another change.', 'CartUncertainError'); blocked.bdCartCode = 'CART_MUTATION_ABORTED'; throw blocked; }
      if (info.mutation === 'add' && typeof window.BizDecksCartGuardValidateItems === 'function') {
        var validated;
        try { validated = window.BizDecksCartGuardValidateItems(requestedItems, trigger); }
        catch (e) { e.bdCartCode = 'CART_PREFLIGHT_FAILED'; throw e; }
        if (validated && validated.ok === false) {
          addPending=false; setStatus('error', validated.message || 'This item cannot be added to your cart.');
          var rejected = annotate(new Response(JSON.stringify({ status: 422, message: validated.message, description: validated.message, physicalDeliveryBlocked: validated.physicalDeliveryBlocked === true }), { status: 422, headers: { 'Content-Type': 'application/json' } }), revision);
          rejected.bdCartValidation = { physicalDeliveryBlocked: validated.physicalDeliveryBlocked === true, changed: false, revision: revision };
          return rejected;
        }
      }
      var matches=info.mutation==='add'?replay.find(requestedItems):[];
      if(matches.length){
        var checked=await rawReadCart();
        if(matches.every(function(record){return replay.fulfilled(record,checked);})){replay.forget(matches);lastCart=checked;cartSeenAt=Date.now();var restored=annotate(new Response(JSON.stringify(checked),{headers:{'Content-Type':'application/json'}}),revision);restored.bdCartAddConfirmed=true;restored.bdCartOutcome='confirmed';scheduleRefresh();return restored;}
        var waiting=error('Your previous add is still unconfirmed. Review your cart before adding the same item again.','CartUncertainError');waiting.bdCartMessage=T('err_prev_add',waiting.message);waiting.bdCartCode='CART_MUTATION_ABORTED';throw waiting;
      }
      var interaction = info.mine ? 'workbook_sync' : info.mutation === 'add' ? 'add_to_cart' : info.mutation === 'clear' ? 'clear_cart' : 'change_quantity';
      try { if (!info.mine && info.mutation === 'change' && Number(JSON.parse(init && init.body || '{}').quantity) === 0) interaction = 'remove_from_cart'; } catch (_) {}
      var action = beginAction(interaction, { request_endpoint: endpoint(input, init) });
      info.action_ref = action.action_ref;
      recoveredUnknown = false; writing = true; revision += 1; setStatus('loading', T('updating', 'Updating your cart...'));
      emit('bd:cart:mutation-start', { revision: revision, operation: info.mutation });
      try {
        var response = await boundedFetch(input, init, info);
        revision += 1;
        annotate(response, revision);
        response.bdCartActionRef = action.action_ref;
        if (action.action_ref) response.bdCartValidation = { action_ref: action.action_ref, revision: revision, changed: false };
        if (!response.ok) {
          var rejectedPayload = null; try { rejectedPayload = await response.clone().json(); } catch (_) {}
          var validation = response.status === 422 || response.status >= 400 && response.status < 500 && response.status !== 400 && !!rejectedPayload && typeof rejectedPayload === 'object';
          var description = String(rejectedPayload && rejectedPayload.description || '');
          var unavailable = response.status === 422 && /^(?:The product .+ is already sold out\.?|This product is (?:sold out|unavailable)\.?|This variant is (?:sold out|unavailable)\.?)$/i.test(description);
          response.bdCartOutcome = validation ? 'rejected' : 'unknown';
          response.bdCartPartialPossible = info.mutation === 'add' && (response.status === 422 && !unavailable || response.status === 400);
          // A complete 422 may have capped an addition, but Shopify has finished it.
          // Refresh the actual quantities without poisoning later valid mutations.
          if (!validation) markUnknown(entry); else addPending=false;
          actionDone('markActionFailed', action, Object.assign({}, response.bdCartRequest, {outcome: validation ? 'failed' : 'unknown'}));
          setStatus('error', validation ? T('err_qty', 'Please review the available quantity and your cart before trying again.') : T('err_unconfirmed', 'Your last change is unconfirmed. Review your cart before trying again.'));
          var rejectionCode = validation ? (unavailable ? 'PRODUCT_UNAVAILABLE' : 'QUANTITY_LIMIT') : 'CART_MUTATION_HTTP';
          recordError(null, Object.assign({}, action, response.bdCartRequest, { error_code: rejectionCode, outcome: validation ? 'failed' : 'unknown' }));
          if (uncertain) reconcile().then(scheduleRefresh, function () {}); else scheduleRefresh();
        } else {
          var accepted;
          try { accepted = await response.clone().json(); }
          catch (parseError) { parseError.bdCartCode = 'CART_INVALID_JSON'; parseError.bdCartRequest = response.bdCartRequest; throw parseError; }
          var validAdd = accepted && (accepted.id || accepted.variant_id || Array.isArray(accepted.items) && accepted.items.length > 0 && accepted.items.every(function (item) { return item && (item.id || item.variant_id); }));
          if (!accepted || typeof accepted !== 'object' || (info.mutation === 'add' ? !validAdd : !Array.isArray(accepted.items) || typeof accepted.item_count !== 'number')) { var invalid = error('Your cart response was incomplete.', 'CartInvalidResponseError'); invalid.bdCartCode = 'CART_INVALID_RESPONSE'; invalid.bdCartRequest = response.bdCartRequest; throw invalid; }
          response.bdCartAddConfirmed = info.mutation === 'add'; response.bdCartOutcome = 'confirmed';
          if (info.mutation === 'add') syncCheckout({items:accepted.items || [accepted],item_count:Math.max(1,Number(accepted.item_count)||1)});
          actionDone('markActionSucceeded', action, response.bdCartRequest);
          setStatus('loading',T('updating','Updating your cart...')); scheduleRefresh();
        }
        return response;
      } catch (e) {
        revision += 1; if (info.dispatched&&info.receivedStatus!==422) markUnknown(entry); else addPending=false;
        e.bdCartCode = e.bdCartCode || (e.name === 'TimeoutError' ? 'CART_MUTATION_TIMEOUT' : e.name === 'AbortError' ? 'CART_MUTATION_ABORTED' : 'CART_MUTATION_NETWORK');
        e.bdCartContext = action; e.bdCartOutcome = info.receivedStatus===422?'rejected':info.dispatched?'unknown':'not_sent';
        actionDone('markActionFailed', action, Object.assign({}, e.bdCartRequest || {}, { outcome: info.dispatched ? 'unknown' : 'failed' }));
        reportError(e);
        /* Re-read only. Repeating a timed out POST could add the same item twice. */
        if (uncertain) reconcile().then(scheduleRefresh, function () {}); else if(info.receivedStatus===422)scheduleRefresh();
        throw e;
      } finally {
        writing = false; paintStatus();
        emit('bd:cart:mutation-end', { revision: revision, operation: info.mutation, uncertain: uncertain });
      }
    });
    writeTail = operation.then(function () {}, function () {});
    return operation.catch(function (e) { reportError(e); throw e; }).finally(function () { pendingWrites -= 1; });
  }

  function sectionNames(options) {
    var sections = options && options.sections;
    var names = DEFAULT_SECTIONS.concat(Array.isArray(sections) ? sections : []);
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) { var el = document.getElementById(id); if (el && el.dataset.id) names.push(el.dataset.id); });
    return Array.from(new Set(names));
  }
  async function applySections(sections, cart) {
    var pageCart = document.querySelector("cart-items");
    if (pageCart && typeof pageCart.applyRenderedSections === "function") {
      var focus = document.activeElement, focusId = focus && focus.id, focusInCart = pageCart.contains(focus);
      var scrollX = window.scrollX, scrollY = window.scrollY;
      for (var id of ["main-cart-items", "main-cart-footer"]) {
        var el = document.getElementById(id);
        if (el && el.dataset.id && !sections[el.dataset.id]) throw error("Your cart display was incomplete.");
      }
      var anchor = document.documentElement.style.overflowAnchor;
      document.documentElement.style.overflowAnchor = "none";
      try { await pageCart.applyRenderedSections(Object.assign({}, cart, {sections: sections, bdCartRevision: revision})); }
      catch (e) { document.documentElement.style.overflowAnchor = anchor; throw e; }
      if (focusInCart && focus && !focus.isConnected) {
        var replacement = (focusId && document.getElementById(focusId)) || pageCart.querySelector("button, a, input");
        if (replacement) replacement.focus({preventScroll: true});
      }
      window.scrollTo(scrollX, scrollY);
      requestAnimationFrame(function () {
        window.scrollTo(scrollX, scrollY);
        requestAnimationFrame(function () { document.documentElement.style.overflowAnchor = anchor; });
      });
    }
    var d = drawer();
    if (sections['cart-drawer'] && d) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var source = doc.querySelector('cart-drawer .drawer__inner') || doc.querySelector('#CartDrawer .drawer__inner') || doc.querySelector('.drawer__inner');
      var target = d.querySelector('.drawer__inner');
      if (!source || !target) throw error('Your cart display was incomplete.');
      var active = document.activeElement;
      var focusWasInside = target.contains(active);
      var focusId = focusWasInside && active.id;
      target.replaceWith(source);
      if (wantsOpen && focusWasInside && typeof window.trapFocus === 'function') {
        window.trapFocus(d.querySelector('#CartDrawer') || source, (focusId && document.getElementById(focusId)) || source.querySelector('.drawer__close') || source);
      }
      d.classList.toggle('is-empty', cart.item_count === 0);
      /* Replaced content must retain the intent that exists now, not intent at request start. */
      if (wantsOpen) {
        d.setAttribute('aria-hidden', 'false');
        d.querySelectorAll('#CartDrawer, .drawer__inner').forEach(function (el) { el.setAttribute('aria-hidden', 'false'); });
      } else {
        d.setAttribute('aria-hidden', 'true'); d.classList.remove('active', 'is-open');
        d.querySelectorAll('#CartDrawer, .drawer__inner').forEach(function (el) { el.setAttribute('aria-hidden', 'true'); });
      }
    }
    if (sections['cart-icon-bubble']) {
      var iconDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var from = iconDoc.querySelector('#cart-icon-bubble'), to = document.getElementById('cart-icon-bubble');
      if (from && to) { to.innerHTML = from.innerHTML; to.className = from.className; }
    }
    replay.rendered(cart); addPending=false;
    if (typeof window.BizDecksCartGuardSyncNotice === 'function') window.BizDecksCartGuardSyncNotice(cart);
    emit('bd:cart:rendered', { revision: revision, cart: cart });
  }
  async function render(state, options) {
    options = options || {}; state = state || {};
    var validation = state.bdCartValidation || options.validation || {};
    var cart = validation.cart || state;
    var atRevision = currentRevision(validation.revision) ? validation.revision : currentRevision(state.bdCartRevision) ? state.bdCartRevision : options.revision;
    if (validation.changed || !currentRevision(atRevision) || atRevision !== revision || writing || !Array.isArray(cart.items) || typeof cart.item_count !== 'number' || !state.sections || !state.sections['cart-drawer'] || !state.sections['cart-icon-bubble']) {
      return refresh(options);
    }
    lastCart = cart; cartSeenAt = Date.now(); syncCheckout(cart); await applySections(state.sections, cart); recovered('render'); if (!uncertain) readyStatus();
    return cart;
  }
  function refresh(options) {
    options = options || {};
    if (refreshPromise) return refreshPromise;
    setStatus('loading', uncertain ? T('checking', 'Checking your last cart change...') : T('loading', 'Loading your cart...'));
    var refreshAction = beginAction('refresh_cart');
    refreshPromise = (async function () {
      try {
        await writeTail;
        if (uncertain) await reconcile();
        /* Retry reads only when a real write invalidated their revision. A late read cannot overwrite a new cart. */
        for (var attempt = 0; attempt < 3; attempt += 1) {
          await writeTail;
          var atRevision = revision;
          var names = sectionNames(options);
          var results = await Promise.all([rawReadCart(refreshAction), boundedFetch(root() + '?sections=' + encodeURIComponent(names.join(',')), {
            method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
          }, refreshAction).then(async function (response) {
            try { if (!response.ok) throw error('Your cart display could not be loaded.'); return await response.json(); }
            catch (e) { e.bdCartRequest = response.bdCartRequest; throw e; }
          })]);
          if (atRevision !== revision || writing || pendingWrites > 0) continue;
          var cart = results[0], sections = results[1];
          if (!sections || !sections['cart-drawer'] || !sections['cart-icon-bubble']) throw error('Your cart display was incomplete.');
          lastCart = cart; cartSeenAt = Date.now(); syncCheckout(cart); await applySections(sections, cart); recovered('render', refreshAction); if (uncertain) setStatus('error', T('err_still', 'Your last change is still unconfirmed. Review your cart. Do not add the same item again.')); else readyStatus(); actionDone('markActionSucceeded', refreshAction); return cart;
        }
        throw error('Your cart is still changing. Check it again in a moment.');
      } catch (e) {
        e.bdCartCode = 'CART_DRAWER_REFRESH_FAILED'; e.bdCartContext = refreshAction;
        actionDone('markActionFailed', refreshAction, e.bdCartRequest); reportError(e); throw e;
      }
      finally { refreshPromise = null; }
    })();
    return refreshPromise;
  }

  window.BizDecksCart = {
    isReady: function () { return installed; },
    peekCart: function () { return lastCart && lastCart.bdCartRevision === revision && !writing && !pendingWrites && !uncertain && Date.now() - cartSeenAt < 30000 ? lastCart : null; },
    readCart: readCart, getCart: readCart, refresh: refresh, render: render, open: open,
    noteOpen: noteOpen, noteClosed: noteClosed, reportError: reportError,
    getRevision: function () { return revision; },
    getState: function () { return { phase: phase, revision: revision, writing: writing, pendingWrites: pendingWrites, uncertain: uncertain, open: wantsOpen, intent: intent, status: status }; }
  };
  document.addEventListener('cart:close', noteClosed);
  document.addEventListener('cart:closed', finishClosed);
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('#checkout, #CartDrawer-Checkout, [name="checkout"], a[href="/checkout"]');
    if (target && !target.disabled) monitor('capture', { error_code: 'CHECKOUT_CLICKED', interaction: 'checkout', cart_version: revision });
  }, true);
  /* P3-5 (22 Oct 2026): after a dropped connection the side cart kept "We could not confirm your last change ... Do not add
     the same item again yet" when the phone was back online. On 'online': read the server cart until it is settled (the same
     two matching reads over a quiet period as reconcile), redraw the side cart and clear the notice. A request that is not in
     the settled cart did not arrive (a dead connection never delivers it later), so its receipt is cleared too. No POST is
     sent or repeated here. */
  var onlineCheck = null;
  window.addEventListener('online', function () {
    if (onlineCheck || (!uncertain && !replay.hasPending() && status !== 'error')) return;
    onlineCheck = setTimeout(async function () {
      try {
        if (uncertain) await reconcile();
        else {
          var first = await rawReadCart();
          await new Promise(function (resolve) { setTimeout(resolve, recoveryQuietMs); });
          if (cartFingerprint(first) !== cartFingerprint(await rawReadCart())) return;
        }
        if (uncertain || writing || pendingWrites) return;
        var settled = await rawReadCart();
        if (writing || pendingWrites || settled.bdCartRevision !== revision) return;
        replay.rendered(settled);
        if (replay.hasPending() && typeof replay.acknowledge === 'function') replay.acknowledge();
        addPending = false; recoveredUnknown = false;
        await refresh();
        if (uncertain || writing || pendingWrites) return;
        setStatus('', '');
        var pageError = document.getElementById('cart-errors');
        if (pageError && pageError.dataset.bdCartOwnedError === 'true') { pageError.textContent = ''; delete pageError.dataset.bdCartOwnedError; }
        document.querySelectorAll('[data-bdp-message], [data-bdp-complete-message]').forEach(function (node) {
          if (/^(We could not confirm the cart update|Something went wrong)/.test(node.textContent || '')) node.textContent = '';
        });
        emit('bd:cart:online-recovered', { revision: revision });
      } catch (_) { /* still offline or the read failed: the notice stays, the customer can use "Check cart again" */ }
      finally { onlineCheck = null; }
    }, 300);
  });
  window.fetch = coordinatedFetch; installed = true;
})();
